// Componente per sistema ExeDialog DDT2026 - Step rag_soc
// Autocomplete che chiama verificaDdt ad ogni carattere digitato
import React, { useState, useRef, useEffect } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ValoriVerificati } from './ValoriVerificati';

export function RagSoc(props) {
    const { currURLSearchParams, onFinish, verificaData, verificaDdt, buildInputFromSearchParams } = props;
    const inputRef = useRef();
    
    const [state, setState] = useState({
        rag_soc: currURLSearchParams.get('rag_soc') || ''
    });
    const [suggestions, setSuggestions] = useState([]);
    const [searching, setSearching] = useState(false);

    // righe_suggerimento dalla risposta iniziale (clienti frequenti)
    const suggerimenti = verificaData?.righe_suggerimento || [];

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [verificaData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (state.rag_soc) {
            onFinish({ rag_soc: state.rag_soc });
        }
    };

    // Seleziona riga dalla tabella suggerimenti
    const handleRowSelect = (e) => {
        const row = e.data;
        onFinish({ rag_soc: row.rag_soc });
    };

    // Chiama verificaDdt ad ogni carattere digitato
    const searchOptions = async (event) => {
        const query = event.query;
        if (!query || query.length < 1) {
            setSuggestions([]);
            return;
        }

        setSearching(true);
        try {
            // Costruisce input con i valori correnti URL + il valore parziale di rag_soc
            const currentInput = buildInputFromSearchParams(currURLSearchParams);
            const input = {
                ...currentInput,
                rag_soc: query
            };
            
            const result = await verificaDdt(input);
            // Se il campo è stato verificato (campo_da_verificare è passato al successivo),
            // mostra il valore verificato come unica opzione confermabile
            if (result?.campo_da_verificare !== 'rag_soc') {
                const v = result?.valori_verificati;
                setSuggestions(v?.rag_soc ? [{ rag_soc: v.rag_soc, cod_pers: v.cod_pers }] : []);
            } else {
                setSuggestions(result?.opzioni_selezione || []);
            }
        } catch (err) {
            console.error('Errore ricerca:', err);
            setSuggestions([]);
        } finally {
            setSearching(false);
        }
    };

    // Template per mostrare rag_soc nell'autocomplete
    const itemTemplate = (item) => (
        <span>{item.rag_soc} <span style={{fontSize: 'x-small', color: '#666'}}>({item.cod_pers})</span></span>
    );

    return (
        <div className="card-body">
            <h5 className="card-title">Ragione Sociale Cliente</h5>
            <p className="text-muted">Digita per cercare o seleziona dalla tabella dei clienti frequenti.</p>
            
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="rag_soc" className="form-label">Ragione Sociale</label>
                    <AutoComplete 
                        ref={inputRef}
                        id="rag_soc"
                        value={state.rag_soc}
                        suggestions={suggestions}
                        completeMethod={searchOptions}
                        field="rag_soc"
                        onChange={(e) => {
                            const value = typeof e.value === 'object' ? e.value.rag_soc : e.value;
                            setState({ rag_soc: value });
                        }}
                        onSelect={(e) => {
                            onFinish({ rag_soc: e.value.rag_soc });
                        }}
                        itemTemplate={itemTemplate}
                        className="w-100"
                        inputClassName="w-100"
                        minLength={1}
                        delay={300}
                    />
                    {searching && <small className="text-muted">Ricerca in corso...</small>}
                </div>

                {suggerimenti.length > 0 && (
                    <div className="card mb-3">
                        <DataTable 
                            value={suggerimenti} 
                            selectionMode="single" 
                            onRowSelect={handleRowSelect}
                            size="small"
                            scrollable
                            scrollHeight="400px"
                            header="Destinatari recenti"
                        >
                            <Column field="rag_soc" header="Destinatario" sortable />
                        </DataTable>
                    </div>
                )}

                <button className="btn btn-primary" disabled={!state.rag_soc}>
                    Prosegui
                </button>
            </form>
            
            <ValoriVerificati valori={verificaData?.valori_verificati} />
        </div>
    );
}

RagSoc.displayName = 'rag_soc';
